export { default as FreeInput } from './FreeInput.vue';
